import * as Sentry from '@sentry/sveltekit'

Sentry.init({
  dsn: 'https://240c6a650c7f5f544af227d5777819c1@o4505750928556032.ingest.sentry.io/4505750932750336',
  sendDefaultPii: true,

  enableLogs: true,
  tracesSampleRate: 0.1,
})
export const handleError = Sentry.handleErrorWithSentry()
